import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * Skeleton loader for ChatWindow that matches the exact layout
 * to prevent size jumps when loading completes.
 */
export const ChatWindowSkeleton: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="h-screen w-full flex flex-col"
      style={{ background: '#160C0C' }}
    >
      {/* Header skeleton */}
      <div
        className="flex items-center gap-3 px-4 flex-shrink-0"
        style={{
          paddingTop: 'calc(env(safe-area-inset-top) + 12px)',
          paddingBottom: '12px',
          borderBottom: '1px solid rgba(255,255,255,0.10)',
        }}
      >
        <button
          onClick={() => navigate('/messages')}
          className="p-1 text-white/60 flex-shrink-0"
          aria-label="Back"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        {/* Avatar placeholder */}
        <div className="w-11 h-12 rounded-full bg-white/10 animate-pulse flex-shrink-0" />
        <div className="flex flex-col gap-1.5 min-w-0">
          <div className="w-28 h-3.5 rounded bg-white/10 animate-pulse" />
          <div className="w-20 h-2.5 rounded bg-white/[0.06] animate-pulse" />
        </div>
      </div>

      {/* Messages area — spinner centered */}
      <div className="flex-1 flex items-center justify-center">
        <div className="w-5 h-5 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>

      {/* Input area placeholder */}
      <div
        className="flex-shrink-0 px-4 py-3"
        style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}
      >
        <div className="w-full h-10 rounded-full bg-white/[0.06] animate-pulse" />
      </div>
    </div>
  );
};
